'use client'

import { ActionList } from '@fukku/action-list'
import { LinkListClientItem } from '@fukku/action-list/ListItem/LinkListItem/client/LinkListClientItem'
import type { Question } from 'help/services/questions/types'
import { sendOnClickFAQ } from 'help/utils/analytics/analyticsEvents'
import { ClientLink } from 'utils/link/client'

interface FAQsListProps {
	readonly questions: Question[]
}
export function FAQsList({ questions }: FAQsListProps) {
	return (
		<ActionList showChildrenArrow={false} data-testid='help.faqs.list'>
			{questions.map(({ uid, key, title, url }, index) => (
				<LinkListClientItem
					data-testid={`help.faqs.list.${index}`}
					key={uid}
					title={title}
					linkAttributes={{ href: url }}
					linkAs={ClientLink}
					onClick={() => {
						sendOnClickFAQ({
							questionName: key,
						})
					}}
				/>
			))}
		</ActionList>
	)
}
